import { Injectable } from '@angular/core';
import { FileTransfer } from '@ionic-native/file-transfer/ngx';
import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx';
import { CommonService } from 'src/app/common.service';
import { MobileService } from 'src/app/mobile.services';

declare let window: any;
declare let cordova: any;

@Injectable({
  providedIn: 'root'
})
export class FileOpenerService {

  constructor(private _fileTransfer: FileTransfer, private _fileOpener: FileOpener, private _commonService: CommonService, private _mobileService:MobileService) { }

  openPDF(response, mimeType:string, fileName){
    if(this._mobileService.doEnableSecureHTTP){
      this._fileOpener.open(response.nativeURL, mimeType)
        .then(() => console.log('File is opened'))
        .catch(e => console.log('Error opening file', e));
    } else {
      this.downloadAndOpenPDF(response.body, mimeType, fileName);
    }
  }

  downloadAndOpenPDF(blob, mimeType, fileName) {
    let fileURL = cordova.file.documentsDirectory + fileName;

    let storageLocation = "";
    // switch (this._commonService.deviceInfo.os) {
    switch(this._mobileService.device.platform.toLowerCase()){
      case "android":
        storageLocation = cordova.file.externalDataDirectory;
        break;
      case "ios":
        storageLocation = cordova.file.documentsDirectory;
        break;
    }

    let _this = this;

    let folderPath = storageLocation;
    window.resolveLocalFileSystemURL(
      folderPath,
      function (dir) {
        dir.getFile(
          fileName,
          {
            create: true
          },
          function (file) {
            file.createWriter(
              function (fileWriter) {
                fileWriter.write(blob);

                fileWriter.onwriteend = function () {
                  var url = file.toURL();
                  _this._fileOpener.open(url, mimeType)
                    .then(() => console.log('File is opened'))
                    .catch(e => console.log('Error opening file', e));
                };

                fileWriter.onerror = function (err) {
                  alert("Unable to download");
                  console.error(err);
                };
              },
              function (err) {
                // failed
                alert("Unable to download");
                console.error(err);
              }
            );
          },
          function (err) {
            alert("Unable to download");
            console.error(err);
          }
        );
      },
      function (err) {
        alert("Unable to download");
        console.error(err);
      }
    );
  }

  openTermsPDF(fileName:string){
    let filePath = cordova.file.applicationDirectory + 'www/assets/documents/' + fileName;
    this._fileOpener.open(filePath, "application/pdf")
      .then(() => console.log('File is opened'))
      .catch(e => console.log('Error opening file', e));

  }

}
